module.exports = __webpack_public_path__ + "static/media/disloyalty-to-the-us.905fc4d6.svg";